import { useCallback } from 'react';

import { usePublish } from '@atlaskit/rovo-triggers';

import { fg } from '@confluence/feature-gating';

export const usePublishDatabaseReferencingContent = (): {
	publishDatabaseReferencingContent: (selectedElementIds: string[] | undefined) => void;
} => {
	const publish = usePublish('ai-mate');

	const publishDatabaseReferencingContent = useCallback(
		(selectedElementIds: string[] | undefined): void => {
			// eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Existing gate retained during CCP-9677 lint-rule rollout; migration deferred.
			if (fg('confluence_frontend_rovo_db_referencing_content')) {
				publish({
					type: 'database-context-payload',
					source: 'CONFLUENCE_DATABASE',
					openChat: false,
					data: {
						selectedElementIds,
					},
				});
			}
		},
		[publish],
	);

	return { publishDatabaseReferencingContent };
};
